/**
 * company-i18n.ts — lecture FR/EN de la description d'entreprise (client_accounts).
 * Calque d'offer-i18n.ts : choisit la variante selon la langue, fallback croisé
 * puis legacy. cf. company-translator.ts pour l'écriture.
 */
export function pickCompanyDescription(
  account: { descriptionFr?: string | null; descriptionEn?: string | null; description?: string | null } | null | undefined,
  language: string | undefined,
): string {
  if (!account) return "";
  const fr = account.descriptionFr?.trim() || "";
  const en = account.descriptionEn?.trim() || "";
  const legacy = account.description?.trim() || "";
  const isFr = (language || "fr").toLowerCase().startsWith("fr");
  return isFr ? (fr || en || legacy) : (en || fr || legacy);
}
